import { digiAccActorType } from "../common/TextTypes";
import { IActorModel, IActorPostModel, IActorPutModel } from "./model/IActorModel";
import PageResult from "./rest_api_connection/PageResult";
import { DefaultResult, Result } from "./rest_api_connection/Result";
import { ServiceBase } from "./rest_api_connection/ServiceBase";

export default class ActorService extends ServiceBase {

    public async getCustomers(
        organizationId: string, page?: number, pageSize?: number, freeText?: string
    ): Promise<PageResult<IActorModel[]>> {

        let url = "/Organization/" + organizationId + "/Actor/Customers?";

        let terms: string[] = [];

        if (page) {
            terms.push("page=" + page);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJsonPaged<IActorModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }
    public async getSuppliers(
        organizationId: string, page?: number, pageSize?: number, freeText?: string
    ): Promise<PageResult<IActorModel[]>> {

        let url = "/Organization/" + organizationId + "/Actor/Suppliers?";

        let terms: string[] = [];

        if (page) {
            terms.push("page=" + page);
        }
        if (pageSize) {
            terms.push("pageSize=" + pageSize);
        }
        if (freeText) {
            terms.push("freeText=" + freeText);
        }

        let termsUrl = terms.join("&");

        var result = await this.requestJsonPaged<IActorModel[]>({
            url: url + termsUrl,
            method: "GET"
        });
        return result;
    }

    public async postActor(organizationId: string, type: digiAccActorType, data: IActorPostModel): Promise<DefaultResult> {

        let actor = "";
        if (type === "Supplier") {
            actor = "Suppliers";
        } else {
            actor = "Customers";
        }

        let url = "/Organization/" + organizationId + "/Actor/" + actor;

        var result = await this.requestJsonDefault({
            url: url,
            method: "POST",
            data: data
        })
        return result;
    }

    public async putActor(organizationId: string, type: digiAccActorType, id: number, data: IActorPutModel): Promise<DefaultResult> {

        let actor = "";
        if (type === "Supplier") {
            actor = "Suppliers";
        } else {
            actor = "Customers";
        }

        let url = "/Organization/" + organizationId + "/Actor/" + actor + "/" + id;

        var result = await this.requestJsonDefault({
            url: url,
            method: "PUT",
            data: data
        })
        return result;
    }

}
